<template>
    <v-card flat tile class="transparent d-flex flex-nowrap align-center justify-space-around" :class="isMirrored ? 'flex-row-reverse' : ''" height="60px" width="100%">
        <v-card flat tile class="transparent theme-title timeline-title d-flex align-center justify-center" height="60px">
            <span class="team-name">{{teams['A'].name}}</span>
            <span class="active-players">{{teams['A'].active}}</span>
        </v-card>
        <v-card flat tile class="transparent theme-title timeline-title d-flex align-center justify-center" height="60px">
            <span class="team-name">{{teams['B'].name}}</span>
            <span class="active-players">{{teams['B'].active}}</span>
        </v-card>
    </v-card>
</template>

<script>
    export default {
        name: 'TimelineHeader',
        props: {
            teams: Object,
            isMirrored: Boolean,
        },
    }
</script>

<style scoped>
    .timeline-title {
        font-size: 16px;
        font-weight: bold;
        font-stretch: condensed;
        font-family: 'Roboto Condensed';
        width: 50%;
        padding-left: 10px;
        padding-right: 10px;
    }

    .active-players {
        padding-left: 8px;
        color: #23C373;
    }

    .team-name {
        display: block;
        max-width: calc(100% - 20px);
        white-space: nowrap;
        text-overflow: ellipsis;
        overflow: hidden;
    }
</style>